import { connect } from 'react-redux'
import TripActivityLog from '../../components/trips/trip-detail/TripActivityLog'
import * as actions from '../../state/actions/trips'
import * as userActions from '../../state/actions/users'
import { IStoreState } from '../../types'
import { RouteComponentProps, withRouter } from 'react-router-dom'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  const currentTrip = ownProps.currentTrip
  return {
    currentTrip
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getManyStatusesById: async (tripId: string) => actions.getManyStatusesById(tripId),
    fetchUserById: async (id: string) => userActions.fetchById(id)
  }
}

export default withRouter(
  connect<RouteComponentProps<any>, any, any>(
    mapStateToProps,
    mapDispatchToProps
  )(TripActivityLog)
)



// WEBPACK FOOTER //
// ./src/containers/trips/TripActivityLog.ts